import styled from 'styled-components'
import { Row } from 'reactstrap'

export const ButtonContainer = styled.div`
  float: right;
  padding-top: 0.5rem;
`

export const StyledRow = styled(Row)`
  background-color: #002855;
`



// WEBPACK FOOTER //
// ./src/components/Site/component.styles.js